import { instance, instanceApi } from 'libs';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import * as Types from 'types';

export const getListAgent = (
  params: Types.GetListAgentRequest
): AxiosPromise<Types.GetListAgentResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/agent',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const getAlbums = (
  params: Types.GetAlbumsRequest
): AxiosPromise<Types.GetAlbumsResponse> => {
  const request: AxiosRequestConfig = {
    url: '/sites/images',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getSiteShopList = (
  params: Types.GetUserSiteShopListRequest
): AxiosPromise<Types.GetUserSiteShopListResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/cooperator_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getSiteShopListToday = (
  params: Types.GetUserSiteShopListTodayRequest
): AxiosPromise<Types.GetUserSiteShopListTodayResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/cooperator_list/today',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// 2025/02/25 FJ 3月分反映分 NO32 start
export const getSiteFirstCooperatorListToday = (
  params: Types.GetUserSiteShopListTodayRequest
): AxiosPromise<Types.GetUserSiteShopListTodayResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/first_cooperator_list/today',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 end

export const deleteImage = (
  data: Types.DeleteImageRequest
): AxiosPromise<Types.DeleteImageResponse> => {
  const request: AxiosRequestConfig = {
    url: '/image/delete',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

export const getStatusKy = (
  params: Types.GetStatusKyRequest
): AxiosPromise<Types.GetStatusKyResponse> => {
  const request: AxiosRequestConfig = {
    url: '/ky_datas_approved_by_site_director',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
export const getDetailImage = (
  params: Types.GetDetailImageRequest
): AxiosPromise<Types.GetDetailImageResponse> => {
  const request: AxiosRequestConfig = {
    url: '/image',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getMapDetail = (
  params: Types.GetMapDetailRequest
): AxiosPromise<Types.GetMapDetailResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/detail',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const addImages = (data: Types.AddImageRequest): AxiosPromise<Types.AddImageResponse> => {
  const request: AxiosRequestConfig = {
    url: '/image/new',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

export const uploadImages = (
  data: Types.UploadImagesRequest
): AxiosPromise<Types.UploadImagesResponse> => {
  const request: AxiosRequestConfig = {
    url: '/image/upload',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

export const getSiteActiveStatus = (
  params: Types.GetSiteActiveStatusRequest
): AxiosPromise<Types.GetSiteActiveStatusResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/active_status',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// /site/cooperator/users/schedules

export const getSiteCooperatorUsersSchedules = (
  params: Types.SiteCooperatorUsersSchedulesParams
): AxiosPromise<Types.SiteCooperatorUsersSchedulesResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/cooperator/users/schedules',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// site/status_locked

export const getSiteStatusLocked = (
  params: Types.GetSiteStatusLockedParams
): AxiosPromise<Types.GetSiteStatusLockedResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/status_locked',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// /site/users/status

export const getSiteUserStatus = (
  params: Types.SiteUsersStatusParams
): AxiosPromise<Types.SiteUsersStatusRespon> => {
  const request: AxiosRequestConfig = {
    url: '/site/users/status',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// 2025/02/25 FJ 3月分反映分 NO32 start
// /site/users/status/group
export const getSiteUserGroupStatus = (
  params: Types.SiteUsersGroupStatusParams
): AxiosPromise<Types.SiteUsersStatusRespon> => {
  const request: AxiosRequestConfig = {
    url: '/site/users/status/group',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 end

// /ky
export const getKy = (params: Types.GetKyParams): AxiosPromise<Types.GetKyResponse> => {
  const request: AxiosRequestConfig = {
    url: '/ky',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// 2025/02/25 FJ 3月分反映分 NO32 start
// /kyGroup
export const getKyGroup = (params: Types.GetKyGroupParams): AxiosPromise<Types.GetKyResponse> => {
  const request: AxiosRequestConfig = {
    url: '/ky/group',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 end

// today_slingtool

export const getTodaySlingtool = (
  params: Types.TodaySlingToolparams
): AxiosPromise<Types.TodaySlingToolResponse> => {
  const request: AxiosRequestConfig = {
    url: '/today_slingtool',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 start
export const getTodaySlingtoolGroup = (
  params: Types.TodaySlingToolGroupparams
): AxiosPromise<Types.TodaySlingToolResponse> => {
  const request: AxiosRequestConfig = {
    url: '/today_slingtool/group',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 end
// /today_footingcheck

export const getTodayFootingCheck = (
  params: Types.TodayFootingcheckParams
): AxiosPromise<Types.TodayFootingcheckResponse> => {
  const request: AxiosRequestConfig = {
    url: '/today_footingcheck',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 start
export const getTodayFootingCheckGroup = (
  params: Types.TodayFootingcheckGroupParams
): AxiosPromise<Types.TodayFootingcheckResponse> => {
  const request: AxiosRequestConfig = {
    url: '/today_footingcheck/group',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 end

// /today_safetyorder

export const getTodaySafetyOrder = (
  params: Types.TodaySafetyOrderParams
): AxiosPromise<Types.TodaySafetyOrderResponse> => {
  const request: AxiosRequestConfig = {
    url: '/today_safetyorder',
    // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
    // method: 'GET',
    // params,
    method: 'POST',
    data: params,
    // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
  };
  return instanceApi(request);
};

// 2025/02/25 FJ 3月分反映分 NO32 start
export const getTodaySafetyOrderGroup = (
  params: Types.TodaySafetyOrderGroupParams
): AxiosPromise<Types.TodaySafetyOrderResponse> => {
  const request: AxiosRequestConfig = {
    url: '/today_safetyorder/group',
    method: 'POST',
    data: params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 end

// 2025/06/30 LW No.79 RKY出力対応 start
export const getSiteOutputRKYList = (
  params: Types.SiteRKYDataListParams
): AxiosPromise<Types.SiteRKYDataListResponse[]> => {
  const request: AxiosRequestConfig = {
    url: '/site/output/rky',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/06/30 LW No.79 RKY出力対応 end

// 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 start
export const getSiteOutputCooperatorList = (
  params: Types.SiteOutputCooperatorListRequest
): AxiosPromise<Types.SiteOutputCooperatorListResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/output/cooperator_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/9/9　施　匠対応一覧No.89_RKY出力業者選択仕様変更 end

export const getStatusKyApproved = (
  data: Types.GetApprovedRequest
): AxiosPromise<Types.GetApprovedResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/ky_datas_approved_by_site_director',
    method: 'GET',
    data,
  };
  return instanceApi(request);
};

// /ky_datas_approved_by_site_manager

export const getKYDataApproveBySiteManage = (
  params: Types.GetKYDataApproveBySiteManageRequest
): AxiosPromise<Types.GetKYDataApproveBySiteManageResponse> => {
  const request: AxiosRequestConfig = {
    url: '/ky_datas_approved_by_site_manager',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// 2025/02/25 FJ 3月分反映分 NO32 start
export const getKYDataApproveGroupBySiteManage = (
  params: Types.GetKYDataApproveGroupBySiteManageRequest
): AxiosPromise<Types.GetKYDataApproveBySiteManageResponse> => {
  const request: AxiosRequestConfig = {
    url: '/ky_datas_approved_by_site_manager/group',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 end

// /rky_check_status/update
export const updateRkyCheckStatus = (
  data: Types.RkyCheckStatusData
): AxiosPromise<Types.RkyCheckStatusResponse> => {
  const request: AxiosRequestConfig = {
    url: '/rky_check_status/update',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

// /ky/approve
export const updateKyAprove = (
  data: Types.KyApproveData
): AxiosPromise<Types.KyApproveResponse> => {
  const request: AxiosRequestConfig = {
    url: '/ky/approve',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

// /cooperator/user/schedules
export const getCooperatorUserSchedules = (
  params: Types.GetCooperatorUserSchedulesRequest
): AxiosPromise<Types.CooperatorUserSchedulesResponse> => {
  const request: AxiosRequestConfig = {
    url: '/cooperator/user/schedules',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// /workers_site_list
export const getWorkersSiteList = (
  params: Types.getWorkersSiteListRequest
): AxiosPromise<Types.getWorkersSiteListResponse> => {
  const request: AxiosRequestConfig = {
    url: '/workers_site_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// /sites/shop_schedules
export const getSitesShopSchedules = (
  params: Types.GetgetSitesShopSchedulesRequest
): AxiosPromise<Types.GetSitesShopSchedulesResponse> => {
  const request: AxiosRequestConfig = {
    url: '/sites/shop_schedules',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// /site/user/schedules
export const getSiteUserSchedules = (
  params: Types.GetSiteUserSchedulesRequest
): AxiosPromise<Types.GetSiteUserSchedulesResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/user/schedules',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const rkyReturn = (data: Types.RkyRerunRequest): AxiosPromise<Types.RkyRerunResponse> => {
  const request: AxiosRequestConfig = {
    url: '/ky/return',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};
